/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import axios, { acceptDownloadResponse } from "utils/httpClient";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Popup from "reactjs-popup";
import SignaturePad from "react-signature-canvas";
import TSUser from "components/Forms/TSUser";
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
// core components
import Grid from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem.js";
import Col from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Collapse, Modal, ModalBody, Input, Label, } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import PeopleIcon from '@material-ui/icons/People';
import garuda from "assets/img/garuda2.jpg";
import "./custom-style.css";
import ReactFullScreenElement from "react-fullscreen-element";
import KeyboardEventHandler from "react-keyboard-event-handler";
import logoDMS from "assets/img/1_logoDMS.jpg";
import logo from "assets/img/skin.png";
import { YearContext } from "components/CustomYear/YearContext";
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { ListItem } from "@material-ui/core";

var currentUser = "";
if (JSON.parse(localStorage.getItem('currentUser')) !== null) {
    currentUser = JSON.parse(localStorage.getItem('currentUser'))
}

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const styles2 = {
    signatureCanvas: {
        border: "1px solid black",
        width: "100%",
        minHeight: "350px"
    }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

const Edit = props => {
    const [imageURL, setImageURL] = useState(null);
    const [imageURL2, setImageURL2] = useState(null);
    // const [modalPolicy, setModalPolicy] = useState(true);
    const [modal, setModal] = useState(false);
    const [modalSig, setModalSig] = useState(false);
    const [modalSig2, setModalSig2] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [isOpen, setIsOpen] = useState(false);
    const sigCanvas = useRef({});
    const [isMobile, setIsMobile] = useState(false);
    const [fullScreen, setFullScreen] = useState(false);
    const [fullScreen2, setFullScreen2] = useState(false);
    const [configId, setConfigId] = useState(false);
    const [PDF, setPDF] = useState(null);
    const [configPolicy, setConfigPolicy] = useState(false);
    const [modalPolicy, setModalPolicy] = useState(false);
    const [modalPolicy2, setModalPolicy2] = useState(true);
    const [MedicalCertificate, setMedicalCertificate] = useState('');
    const [Academicmission, setAcademicmission] = useState('');
    const [SkinDiseaseHospital, setSkinDiseaseHospital] = useState('');
    const [Name, setName] = useState('');
    const [Directorposition, setDirectorposition] = useState('');
    const [Name1, setName1] = useState('');
    const [Testimonial, setTestimonial] = useState('');
    const [DeputyDirector, setDeputyDirector] = useState('');
    const [Name2, setName2] = useState('');
    const [Date, setDate] = useState('');
    const [Name3, setName3] = useState('');
    const [DeputyMedicalDirector, setDeputyMedicalDirector] = useState('');
    const [Date1, setDate1] = useState('');
    const [indicators, setIndicators] = useState([]);
    const [inputs, setInputs] = useState([]);
    //const [data, setData] = useState([]);
    const { selectedYear } = useContext(YearContext);
    const [responsibleL, setResponsibleL] = useState([]);
    const [responsibleL2, setResponsibleL2] = useState([]);
    const [isClear, setIsClear] = useState(false);

    function toThaiNumber(input) {
        return input.toString().replace(/\d/g, (d) => "๐๑๒๓๔๕๖๗๘๙"[d]);
    }

    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const { location, ...other } = props;

    // แก้ไข eqeqeq: != เป็น !==
    const _titleId = (location.state !== null && (location.state.titleId !== null && location.state.titleId !== '')) ? location.state.titleId : null;

    const handleAddInput = () => {
        setInputs([...inputs, { id: window.Date.now(), value: "" }]);
    };

    const useTreeItemStyles = makeStyles((theme) => ({
        root: {
            color: theme.palette.text.secondary,
            '&:hover > $content': {
                backgroundColor: theme.palette.action.hover,
            },
            '&:focus > $content, &$selected > $content': {
                backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
                color: 'var(--tree-view-color)',
            },
            '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
                backgroundColor: 'transparent',
            },
        },
        content: {
            color: theme.palette.text.secondary,
            borderTopRightRadius: theme.spacing(2),
            borderBottomRightRadius: theme.spacing(2),
            paddingRight: theme.spacing(1),
            fontWeight: theme.typography.fontWeightMedium,
            '$expanded > &': {
                fontWeight: theme.typography.fontWeightRegular,
            },
        },
        group: {
            marginLeft: 0,
            '& $content': {
                paddingLeft: theme.spacing(2),
            },
        },
        expanded: {},
        selected: {},
        label: {
            fontWeight: 'inherit',
            color: 'inherit',
        },
        labelRoot: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0.5, 0),
        },
        labelIcon: {
            marginRight: theme.spacing(1),
        },
        labelText: {
            fontWeight: 'inherit',
            flexGrow: 1,
            fontSize: '1.2rem',
            fontFamily: '"Sarabun", sans-serif',
        },
    }));

    function StyledTreeItem(props) {
        const classes = useTreeItemStyles();
        const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, ...other } = props;

        return (
            <TreeItem
                label={
                    <div className={classes.labelRoot}>
                        <LabelIcon color="inherit" className={classes.labelIcon} />
                        <Typography variant="body2" className={classes.labelText}>
                            {labelText}
                        </Typography>
                        <Typography variant="caption" color="inherit">
                            {labelInfo}
                        </Typography>
                    </div>
                }
                style={{
                    '--tree-view-color': color,
                    '--tree-view-bg-color': bgColor,
                }}
                classes={{
                    root: classes.root,
                    content: classes.content,
                    expanded: classes.expanded,
                    selected: classes.selected,
                    group: classes.group,
                    label: classes.label,
                }}
                {...other}
            />
        );
    }

    StyledTreeItem.propTypes = {
        bgColor: PropTypes.string,
        color: PropTypes.string,
        labelIcon: PropTypes.elementType.isRequired,
        labelInfo: PropTypes.string,
        labelText: PropTypes.string.isRequired,
    };
    const handleInputChange = (id, newValue) => {
        setInputs((prevInputs) =>
            prevInputs.map((input) =>
                input.id === id ? { ...input, value: newValue } : input
            )
        );
    };

    const handleRemoveInput = (id) => {
        // ลบเฉพาะ input ที่ id ไม่เท่ากับที่ต้องการลบ
        const updatedInputs = inputs.filter(input => input.id !== id);

        // สร้าง indicators ใหม่ให้สัมพันธ์กับ input ที่เหลือ
        const updatedIndicators = updatedInputs.map((_, idx) => ` ${idx + 1}`);

        // ตั้งค่าใหม่
        setInputs(updatedInputs);
        setIndicators(updatedIndicators);
    };


    function setFullScreenKey(e) {
        if (
            e === "esc"
        ) {
            setFullScreen(false);
        }
    }


    const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };


    const setBoth = () => {
        const newIndicator = ` ${indicators.length + 1}`;
        setIndicators([...indicators, newIndicator]);
        console.log(indicators);
        handleAddInput();
    }



    // create an event listener
    useEffect(() => {
        window.addEventListener("resize", handleResize);
    });

    const clear = () => sigCanvas.current.clear();

    const save = () =>
        setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));

    const save2 = () =>
        setImageURL2(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));

    const classes = useStyles();
    const classes2 = useStyles2();

    const handleSubmit = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var errMsg = [];

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            setModalSig(true);
            setModal(true);
        }
    };


    const handleSubmitEdit = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var errMsg = [];

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            setModalEdit(true);
        }
    };

    function DataURIToBlob(dataURI) {
        const splitDataURI = dataURI.split(",");
        const byteString =
            splitDataURI[0].indexOf("base64") >= 0
                ? atob(splitDataURI[1])
                : decodeURI(splitDataURI[1]);
        const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i);

        return new Blob([ia], { type: mimeString });
    }

    function handleConfirm() {
        setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        const fileField = DataURIToBlob(
            sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
        );
        const file = new File([fileField], "File name", { type: "image/png" });
        const formData = new FormData();
        formData.append("files", file);
        axios.post("/api/v1/data/signature/" + 1,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(
                result => {
                    // แก้ไข eqeqeq: == เป็น ===
                    if (result.data.result === 200) {
                        setModalSig(false);
                        setIcon("far fa-question-circle");
                    }
                }, error => { console.log(error); }
            );
    }

    function handleConfirm2() {
        setImageURL2(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        const fileField = DataURIToBlob(
            sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
        );
        const file = new File([fileField], "File name", { type: "image/png" });
        const formData = new FormData();
        formData.append("files", file);
        axios.post("/api/v1/data/signature/" + 2,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(
                result => {
                    // แก้ไข eqeqeq: == เป็น ===
                    if (result.data.result === 200) {
                        setModalSig2(false);
                        setIcon("far fa-question-circle");
                    }
                }, error => { console.log(error); }
            );
    }

    const handleSubmit2 = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var errMsg = [];

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            setModalSig2(true);
        }
    };

    const handleSubmitPolicy = evt => {
        setConfigPolicy(false);
        // setModalPolicy(true);
        handleSubmitPDF2();
    }

    const handleSubmitPDF = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var errMsg = [];

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            axios("/api/v1/download/pdf/" + 1, {
                method: "POST",
              responseType: "blob",
              validateStatus: acceptDownloadResponse
            })
                .then(response => ((response.status >= 200 && response.status < 300) ? response.data : false))
                .then(
                    blob => {
                        if (!blob) {
                            console.log("ไม่พบไฟล์");
                        } else {
                            var reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onloadend = function () {
                                var base64data = reader.result;
                                setPDF(base64data);
                            };
                        }
                    },
                    error => {
                        console.log(error);
                    }
                );

            setFullScreen(true);
        }
    };

    const handleSubmitPDF2 = evt => {

        var cntErr = 0;
        var errMsg = [];

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            axios("/api/v1/download/pdf/" + 5, {
                method: "POST",
              responseType: "blob",
              validateStatus: acceptDownloadResponse
            })
                .then(response => ((response.status >= 200 && response.status < 300) ? response.data : false))
                .then(
                    blob => {
                        if (!blob) {
                            console.log("ไม่พบไฟล์");
                        } else {
                            var reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onloadend = function () {
                                var base64data = reader.result;
                                setPDF(base64data);
                            };
                        }
                    },
                    error => {
                        console.log(error);
                    }
                );

            setFullScreen2(true);
        }
    };

    const setFullScreenButton = evt => {
        // แก้ไข eqeqeq: == เป็น ===
        if (currentUser.userName === "voraphol") {
            setFullScreen(false);
            var edit = {
                Value: "0"
            };

            axios.put("/api/v1/configSignature/" + 2, edit)
                .then(
                    result => {
                        // แก้ไข eqeqeq: == เป็น ===
                        if (result.status === 200) {
                            setConfigId(false);
                        }
                    },
                    error => { console.log(error); }
                );
        } else {
            setFullScreen(false);
        }
    };

    const setFullScreenButton2 = evt => {
        setFullScreen2(false);
    };

    useEffect(() => {
        axios.get("/api/v1/configSignature/" + 2)
            .then(
                result => {
                    // แก้ไข eqeqeq: == เป็น ===
                    if (result.status === 200) {
                        if (result.data.data.value === "1") {
                            setConfigId(true)
                        }
                    }
                },
                error => { console.log(error); }
            );

        axios.get("/api/v1/configSignature/" + 1)
            .then(
                result => {
                    // แก้ไข eqeqeq: == เป็น ===
                    if (result.status === 200) {
                        if (result.data.data.value === "1") {
                            setConfigPolicy(true)
                        }
                    }
                },
                error => { console.log(error); }
            );
    }, []);

    useEffect(() => {
        axios("/api/v1/download/signature/" + 1, {
            method: "POST",
          responseType: "blob",
          validateStatus: acceptDownloadResponse
        })
            .then(response => ((response.status >= 200 && response.status < 300) ? response.data : false))
            .then(
                blob => {
                    if (!blob) {
                        console.log("ไม่พบไฟล์");
                    } else {
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = function () {
                            var base64data = reader.result;
                            setImageURL(base64data);
                        };
                    }
                },
                error => {
                    console.log(error);
                }
            );

        axios("/api/v1/download/signature/" + 2, {
            method: "POST",
          responseType: "blob",
          validateStatus: acceptDownloadResponse
        })
            .then(response => ((response.status >= 200 && response.status < 300) ? response.data : false))
            .then(
                blob => {
                    if (!blob) {
                        console.log("ไม่พบไฟล์");
                    } else {
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = function () {
                            var base64data = reader.result;
                            setImageURL2(base64data);
                        };
                    }
                },
                error => {
                    console.log(error);
                }
            );
    });

    useEffect(() => {
        axios.get("/api/v1/titleSignature/" + _titleId + "/" + selectedYear)
            .then(
                result => {
                    // แก้ไข eqeqeq: == เป็น ===
                    if (result.status === 200) {
                        setMedicalCertificate(result.data.data.textSignature[0].text);
                        setAcademicmission(result.data.data.textSignature[1].text);
                        setSkinDiseaseHospital(result.data.data.textSignature[2].text);
                        setTestimonial(result.data.data.textSignature[13].text);
                        //setName2(result.data.data.textSignature[7].text);
                        setDirectorposition(result.data.data.textSignature[8].text);
                        setDate(result.data.data.textSignature[9].text);
                        //setName3(result.data.data.textSignature[10].text);
                        setDeputyDirector(result.data.data.textSignature[11].text);
                        setDate1(result.data.data.textSignature[12].text);

                        axios("/api/v1/responsibleSignature/" + _titleId + "/" + 1 + "/" + selectedYear)
                            .then(
                                result => {
                                    var res = result.data;
                                    if (res.length > 0 && res[0] !== null) {
                                        setResponsibleL(res);
                                    }
                                }, error => {
                                    console.log(error);
                                }
                            );

                        axios("/api/v1/responsibleSignature/" + _titleId + "/" + 2 + "/" + selectedYear)
                            .then(
                                result => {
                                    var res = result.data;
                                    if (res.length > 0 && res[0] !== null) {
                                        setResponsibleL2(res);
                                    }
                                }, error => {
                                    console.log(error);
                                }
                            );

                        console.log(result.data.data.textSignature);
                        const inputList = result.data.data.textSignature.slice(14).map((item, index) => ({
                            id: item.id,
                            value: item.text
                        }));

                        setInputs(inputList);
                        console.log(inputList);
                        const indicatorsList = inputList.map((_, idx) => ` ${idx + 1}`);
                        setIndicators(indicatorsList);
                        console.log(indicatorsList);
                    }
                },
                error => { console.log(error); }
            );
    }, [_titleId, selectedYear]); // เพิ่ม selectedYear ใน dependency

    const handleResponsible = (_val) => {
        setResponsibleL(_val);
        console.log(_val);
    };

    useEffect(() => {
        console.log(responsibleL)
        if (responsibleL.length > 0 && responsibleL[0] !== null) {
            const fullName = responsibleL[0].titleName === 'แพทย์หญิง' ? 'นางสาว' + responsibleL[0].firstName + " " + responsibleL[0].lastName
                : responsibleL[0].titleName + responsibleL[0].firstName + " " + responsibleL[0].lastName;
            setName(fullName);
        }
    }, [responsibleL]);

    const handleResponsible2 = (_val) => {
        setResponsibleL2(_val);
    };

    useEffect(() => {
        if (responsibleL2.length > 0 && responsibleL2[0] !== null) {
            const fullName = responsibleL2[0].titleName === 'แพทย์หญิง' ? 'นางสาว' + responsibleL2[0].firstName + " " + responsibleL2[0].lastName
                : responsibleL2[0].titleName + responsibleL2[0].firstName + " " + responsibleL2[0].lastName;
            setName1(fullName);
        }
    }, [responsibleL2]);

    const handleConfirmUpdate = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        var edit = {
            S1: MedicalCertificate,
            S2: Academicmission,
            S3: SkinDiseaseHospital,
            S4: Name,
            S5: Directorposition,
            S6: Name1,
            S7: DeputyDirector,
            S8: '(' + Name + ')',
            S9: Directorposition,
            S10: Date,
            S11: '(' + Name1 + ')',
            S12: DeputyDirector,
            S13: Date1,
            S14: Testimonial,
            ListItem: inputs,
            User1: responsibleL,
            User2: responsibleL2
        };

        axios.put("/api/v1/signature/" + _titleId + "/" + selectedYear, edit)
            .then(
                result => {
                    //var res = result.data;
                    // setShowAdd(false);
                    // //setShowAddMonth(true);
                    // setDisable2(false);
                    // setDisable3(false);
                    // setValue(res.data.dataId.toString());
                    // setLabel(res.data.name);
                    setModalEdit(false);
                    // setDataId(res.data.dataId);
                    setIcon("far fa-question-circle");
                    // setUpdate(true);

                    // axios("/api/v1/responsible/" + res.data.dataId)
                    // .then(
                    //   result => {
                    //     var res = result.data;
                    //     setResponsibleL(res);
                    //     var a = check(res, currentUser.userName);
                    //     if(a) {
                    //       setIsResponsible(true);
                    //     } else {
                    //       setIsResponsible(false);
                    //     }
                    //   }, error => {
                    //     setIsResponsible(false);
                    //     console.log(error);
                    //   }
                    // );  
                },
                error => {
                    setErrMsg(errMsg);
                    setModalError(true);
                    console.log(error);
                }
            );
    };


    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>
                                {MedicalCertificate} {Academicmission} {SkinDiseaseHospital}
                                จังหวัดตรัง
                            </h4>
                            <p className={classes.cardCategoryWhite}>
                                {" "}
                                ประจำปีงบประมาณ พ.ศ. {toThaiNumber(selectedYear)}{" "}
                            </p>
                        </CardHeader>

                        <CardBody>
                            <Grid>
                                <Col xs={12} sm={12} md={12}>
                                    <div style={{ textAlign: "center" }}>
                                        <img
                                            style={{ width: "13%", paddingBottom: "20px" }}
                                            src={garuda}
                                            alt="..."
                                        />
                                    </div>
                                </Col>
                            </Grid>
                            <Grid>
                                <Col xs={12} sm={12} md={12}>
                                    <div style={{ textAlign: "center" }}>
                                        <label
                                            style={{
                                                fontWeight: "bold",
                                                paddingTop: "5px",
                                                fontSize: "18px"
                                            }}
                                        >
                                            <div className="textarea-container" style={{ padding: 0 }}>
                                                <Label for="Address"></Label>
                                                <Input
                                                    id="MedicalCertificate"
                                                    cols="30"
                                                    name="MedicalCertificate"
                                                    placeholder=""
                                                    rows="1"
                                                    type="textarea"
                                                    className="custom"
                                                    style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                    value={MedicalCertificate}
                                                    onChange={e => setMedicalCertificate(e.target.value)}
                                                ></Input>
                                            </div>

                                        </label>
                                        <br />
                                        <label
                                            style={{
                                                fontWeight: "bold",
                                                paddingTop: "5px",
                                                fontSize: "18px"
                                            }}
                                        >
                                            <div className="textarea-container" style={{ padding: 0 }}>
                                                <Label for="Address"></Label>
                                                {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                                <Input
                                                    id="Academicmission"
                                                    cols="30"
                                                    name="Academicmission"
                                                    placeholder=""
                                                    rows="1"
                                                    type="textarea"
                                                    className="custom"
                                                    style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                    value={Academicmission}
                                                    onChange={e => setAcademicmission(e.target.value)}
                                                ></Input>
                                            </div>

                                        </label>
                                        <br />
                                        <label
                                            style={{
                                                fontWeight: "bold",
                                                paddingTop: "5px",
                                                fontSize: "18px"
                                            }}
                                        >
                                            <div className="textarea-container" style={{ padding: 0 }}>
                                                <Label for="Address"></Label>
                                                {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                                <Input
                                                    id="SkinDiseaseHospital"
                                                    cols="50"
                                                    name="SkinDiseaseHospital"
                                                    placeholder=""
                                                    rows="1"
                                                    type="textarea"
                                                    className="custom"
                                                    style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                    value={SkinDiseaseHospital}
                                                    onChange={e => setSkinDiseaseHospital(e.target.value)}
                                                ></Input>
                                            </div>
                                        </label>
                                        <br />
                                        <label
                                            style={{
                                                fontWeight: "bold",
                                                paddingTop: "5px",
                                                fontSize: "18px"
                                            }}
                                        >
                                            ประจำปีงบประมาณ พ.ศ. {toThaiNumber(selectedYear)}{" "}
                                        </label>
                                    </div>
                                </Col>
                            </Grid>
                            <Grid>
                                <Col xs={1} sm={1} md={1}>
                                    <label
                                        style={{
                                            paddingTop: "20px",
                                            fontSize: "16px"
                                        }}
                                    >
                                        ๑.
                                    </label>
                                </Col>
                                <Col xs={11} sm={11} md={11}>
                                    <label
                                        style={{
                                            paddingTop: "20px",
                                            fontSize: "16px"
                                        }}
                                    >
                                        คำรับรองระหว่าง
                                    </label>
                                </Col>
                            </Grid>
                            <Grid style={{ paddingTop: "20px" }}>
                                <Col xs={1} sm={1} md={1}>
                                    <label
                                        style={{
                                            paddingTop: "20px",
                                            fontSize: "16px"
                                        }}
                                    ></label>
                                </Col>
                                <Col xs={4} sm={4} md={3}>
                                    {isMobile ? (
                                        <span style={{ paddingLeft: "10%" }}></span>
                                    ) : (
                                        <span style={{ paddingLeft: "20%" }}></span>
                                    )}
                                    <label style={{ fontSize: "16px", lineHeight: "2em" }}>
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            <Input
                                                id="Name"
                                                cols="25"
                                                name="Name"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px' }}
                                                value={Name}
                                                onChange={e => setName(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                </Col>
                                <Col xs={5} sm={5} md={5}>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            <Input
                                                id="Directorposition"
                                                cols="60"
                                                name="Directorposition"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                value={Directorposition}
                                                onChange={e => setDirectorposition(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                </Col>
                                <Col xs={2} sm={2} md={3}>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em",
                                            margin: "35px"
                                        }}
                                    >
                                        ผู้รับคำรับรอง <br />
                                    </label>
                                </Col>
                            </Grid>
                            <GridItem xs={12} sm={12} md={12}>
                                <TreeView className={classes2.root}
                                    defaultExpanded={['3']}
                                    defaultCollapseIcon={<ArrowDropDownIcon />}
                                    defaultExpandIcon={<ArrowRightIcon />}
                                    defaultEndIcon={<div style={{ width: 24 }} />}>
                                    <StyledTreeItem nodeId="1" labelText="ผู้รับคำรับรอง" labelIcon={PeopleIcon}>
                                        <TSUser value={responsibleL} isMultiple={true} isClear={isClear} onChange={e => { handleResponsible(e) }} />
                                    </StyledTreeItem>
                                </TreeView>
                            </GridItem>
                            <Grid style={{ paddingTop: "5px", textAlign: "center" }}>
                                <Col xs={5} sm={5} md={4}></Col>
                                <Col xs={5} sm={5} md={5}>
                                    <label
                                        style={{
                                            fontSize: "16px"
                                        }}
                                    >
                                        และ
                                    </label>
                                </Col>
                                <Col xs={2} sm={2} md={3}></Col>
                            </Grid>
                            <Grid style={{ paddingTop: "5px" }}>
                                <Col xs={1} sm={1} md={1}>
                                    <label
                                        style={{
                                            paddingTop: "20px",
                                            fontSize: "16px"
                                        }}
                                    ></label>
                                </Col>
                                <Col xs={4} sm={4} md={3}>
                                    {isMobile ? (
                                        <span style={{ paddingLeft: "10%" }}></span>
                                    ) : (
                                        <span style={{ paddingLeft: "20%" }}></span>
                                    )}
                                    <label style={{ fontSize: "16px", lineHeight: "2em" }}>
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="Name1"
                                                cols="25"
                                                name="Name1"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px' }}
                                                value={Name1}
                                                onChange={e => setName1(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                </Col>
                                <Col xs={5} sm={5} md={5}>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="DeputyDirector"
                                                cols="60"
                                                name="DeputyDirector"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px' }}
                                                value={DeputyDirector}
                                                onChange={e => setDeputyDirector(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                </Col>
                                <Col xs={2} sm={2} md={3}>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em",
                                            margin: "35px"
                                        }}
                                    >
                                        ผู้ทำคำรับรอง <br />
                                    </label>
                                </Col>
                            </Grid>
                            <GridItem xs={12} sm={12} md={12}>
                                <TreeView className={classes2.root}
                                    defaultExpanded={['3']}
                                    defaultCollapseIcon={<ArrowDropDownIcon />}
                                    defaultExpandIcon={<ArrowRightIcon />}
                                    defaultEndIcon={<div style={{ width: 24 }} />}>
                                    <StyledTreeItem nodeId="2" labelText="ผู้ทำคำรับรอง" labelIcon={PeopleIcon}>
                                        <TSUser value={responsibleL2} isMultiple={true} isClear={isClear} onChange={e => { handleResponsible2(e) }} />
                                    </StyledTreeItem>
                                </TreeView>
                            </GridItem>
                            <Grid>
                                <Col xs={1} sm={1} md={1}>
                                    <label
                                        style={{
                                            paddingTop: "20px",
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        ๒.
                                    </label>
                                </Col>
                                <Col xs={11} sm={11} md={11} style={{ position: "relative" }}>
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        <div className="textarea-container">
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="Testimonial"
                                                cols="200"
                                                name="Testimonial"
                                                placeholder=""
                                                rows="5"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '100px' }}
                                                value={Testimonial}
                                                onChange={e => setTestimonial(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                </Col>
                            </Grid>
                            {inputs.length > 0 && indicators.length === inputs.length && (
                                inputs.map((input, index) => {
                                    const offset = 2;
                                    const thaiNumerals = indicators[index].replace(/\d/g, (digit) => {
                                        const Digit = (parseInt(digit) + offset) % 10
                                        return "๐๑๒๓๔๕๖๗๘๙"[Digit]
                                    });
                                    return (
                                        <Grid>
                                            <Col xs={1} sm={1} md={1} style={{ padding: "10px", marginBottom: "20px" }}>
                                                <label
                                                    style={{
                                                        paddingTop: "20px",
                                                        fontSize: "16px",
                                                        lineHeight: "2em"
                                                    }}
                                                >
                                                    {thaiNumerals}
                                                </label>
                                            </Col>
                                            <Col xs={11} sm={11} md={11} style={{ position: "relative", marginTop: "20px", marginBottom: "10px" }}>
                                                {/* ช่อง Input */}
                                                <Input
                                                    id={input.id}
                                                    cols="200"
                                                    name={input.id}
                                                    placeholder=""
                                                    rows="5"
                                                    type="textarea"
                                                    className="custom"
                                                    style={{
                                                        fontSize: "1em",
                                                        maxHeight: "100px",
                                                        paddingRight: "40px", // เผื่อระยะสำหรับปุ่มลบ
                                                    }}
                                                    value={input.value}
                                                    onChange={(e) => handleInputChange(input.id, e.target.value)}
                                                />
                                                {/* ปุ่มลบ */}
                                                <button
                                                    onClick={() => handleRemoveInput(input.id)} // เพิ่มฟังก์ชันลบตามต้องการ
                                                    style={{
                                                        position: "absolute",
                                                        right: "5px", // ชิดขอบขวาของช่อง
                                                        top: "50%", // จัดกึ่งกลางแนวตั้ง
                                                        transform: "translateY(-50%)",
                                                        backgroundColor: "red",
                                                        color: "white",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        padding: "5px 10px",
                                                        fontSize: "0.9em",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    ลบ
                                                </button>
                                            </Col>
                                        </Grid>
                                    );
                                })
                            )}
                            {/* --ปุ่มเพิ่ม */}
                            {/* <GridItem xs={5} sm={3} md={3} style={{ height: "48px",marginBottom: "20px" }}>
                                <div style={{ textAlign: "center", overflow: "overlay" }}>
                                  <Button color="info" onClick={() => setBoth()}>
                                    <h4>เพิ่ม</h4>
                                  </Button>
                                </div>
              </GridItem> */}
                            <Grid>
                                <Col xs={6} sm={6} md={6} style={{ textAlign: "center" }}>
                                    {/* แก้ไข eqeqeq: == เป็น === */}
                                    {imageURL2 ? (
                                        <div
                                            style={{
                                                paddingTop: "9em"
                                            }}
                                        >
                                            {imageURL ? (
                                                <img
                                                    src={imageURL}
                                                    alt="my signature"
                                                    style={{
                                                        display: "block",
                                                        margin: "0 auto",
                                                        //width: "50%"
                                                        height: "150px"
                                                    }}
                                                />
                                            ) : (currentUser.userName === "madarakung" || currentUser.userName === "voraphol") && (
                                                <Button color="primary" onClick={handleSubmit}>
                                                    <h6 style={{ fontSize: "16px" }}>ลงนาม</h6>
                                                </Button>
                                            )}
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </Col>
                            </Grid>
                            <Grid>
                                <Col xs={6} sm={6} md={6} style={{ textAlign: "center" }}>
                                    {" "}
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em",
                                            paddingTop: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="Name2"
                                                cols="30"
                                                name="Name2"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                //value={Name2}
                                                value={'(' + Name + ')'}
                                                onChange={e => setName2('(' + Name + ')')}
                                            ></Input>
                                        </div>
                                    </label>
                                    <br />
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="Acting"
                                                cols="60"
                                                name="Acting"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                value={Directorposition}
                                                onChange={e => setDirectorposition(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                    <br />
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="Date"
                                                cols="30"
                                                name="Date"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                value={Date}
                                                onChange={e => setDate(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                    <br />
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        ผู้รับคำรับรอง
                                    </label>
                                    <br />
                                    {/* แก้ไข eqeqeq: == เป็น === */}
                                    {imageURL && (currentUser.userName === "madarakung" || currentUser.userName === "voraphol") ? (
                                        <Button color="primary" onClick={handleSubmit}>
                                            <h6 style={{ fontSize: "16px" }}>แก้ไข</h6>
                                        </Button>
                                    ) : (
                                        <label></label>
                                    )}
                                </Col>
                                <Col xs={6} sm={6} md={6} style={{ textAlign: "center" }}>
                                    {" "}
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em",
                                            paddingTop: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="Name3"
                                                cols="30"
                                                name="Name3"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                value={'(' + Name1 + ')'}
                                                onChange={e => setName3('(' + Name1 + ')')}
                                            ></Input>
                                        </div>
                                    </label>
                                    <br />
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="DeputyMedicalDirector"
                                                cols="60"
                                                name="DeputyMedicalDirector"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                value={DeputyDirector}
                                                onChange={e => setDeputyDirector(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                    <br />
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address"></Label>
                                            {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามาแรถแก้ไขที่อยู่จัดส่งได้)*/}
                                            <Input
                                                id="Date1"
                                                cols="30"
                                                name="Date1"
                                                placeholder=""
                                                rows="1"
                                                type="textarea"
                                                className="custom"
                                                style={{ fontSize: '1em', maxHeight: '40px', textAlign: 'center' }}
                                                value={Date1}
                                                onChange={e => setDate1(e.target.value)}
                                            ></Input>
                                        </div>
                                    </label>
                                    <br />
                                    <label
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "2em"
                                        }}
                                    >
                                        ผู้ทำคำรับรอง
                                    </label>
                                    <br />
                                    {/* แก้ไข eqeqeq: == เป็น === */}
                                    {imageURL2 ? (
                                        <Grid>
                                            {(currentUser.userName === "madarakung" || currentUser.userName === "voraphol") && (<Col xs={12} sm={12} md={12} >
                                                <Button color="primary" onClick={handleSubmit2}>
                                                    <h6 style={{ fontSize: "16px" }}>แก้ไข</h6>
                                                </Button>
                                            </Col>)}
                                            <Col xs={12} sm={12} md={12}>
                                                <Button color="primary" onClick={handleSubmitPDF}>
                                                    <h6 style={{ fontSize: "16px" }}> ตัวชี้วัด</h6>
                                                </Button>
                                            </Col>
                                        </Grid>
                                    ) : (
                                        <label></label>
                                    )}
                                </Col>
                            </Grid>
                        </CardBody>
                        <CardFooter className="modal-header justify-content-center">
                            <Collapse isOpen={isOpen}>
                            </Collapse>
                            <div>
                                {/* {(currentUser.userName == "madarakung") && (
                  <Button color="primary" onClick={handleSubmitEdit} >
                    <h4>แก้ไขข้อมูล</h4>
                  </Button>
                )} */}
                                <Button color="primary" onClick={handleSubmitEdit} >
                                    <h4>แก้ไขข้อมูล</h4>
                                </Button>
                            </div>
                            {/* Confirm */}
                            <Modal toggle={() => setModalEdit(false)} isOpen={modalEdit}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalEdit(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirmUpdate}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <div>{errMsg}</div>
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>

                            <Modal toggle={() => setModalSig(false)} isOpen={modalSig}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <div
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        <SignaturePad
                                            ref={sigCanvas}
                                            canvasProps={{
                                                className: classes2.signatureCanvas
                                            }}
                                            style={{
                                                border: "1px solid black",
                                                width: "100%",
                                                minHeight: "300px"
                                            }}
                                        />
                                    </div>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalSig(false)}
                                    >
                                        <h4>ปิด</h4>
                                    </Button>

                                    <Button color="primary" type="button" onClick={clear}>
                                        <h4>Clear</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>บันทึก</h4>
                                    </Button>
                                </div>
                            </Modal>

                            <Modal toggle={() => setModalSig2(false)} isOpen={modalSig2}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <div
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        <SignaturePad
                                            ref={sigCanvas}
                                            canvasProps={{
                                                className: classes2.signatureCanvas
                                            }}
                                            style={{
                                                border: "1px solid black",
                                                width: "100%",
                                                minHeight: "300px"
                                            }}
                                        />
                                    </div>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalSig2(false)}
                                    >
                                        <h4>ปิด</h4>
                                    </Button>

                                    <Button color="primary" type="button" onClick={clear}>
                                        <h4>Clear</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm2}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>บันทึก</h4>
                                    </Button>
                                </div>
                            </Modal>


                            {!configPolicy && imageURL === null && <Modal toggle={() => setModalPolicy(false)} isOpen={modalPolicy} size="lg">
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                    </p>

                                    <Grid>
                                        <Col xs={12} sm={12} md={12}>
                                            <div style={{ textAlign: "center" }}>
                                                <img
                                                    style={{ width: "13%", paddingBottom: "20px" }}
                                                    src={logo}
                                                    alt="..."
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                                            <label
                                                style={{
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                นโยบายการคุ้มครองข้อมูลส่วนบุคคล <br></br>
                                                ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง พ.ศ. ๒๕๖๗
                                            </label>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "left" }}>
                                            <label
                                                style={{
                                                    fontSize: "16px",
                                                    paddingTop: "10px"
                                                }}
                                            >
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                จัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคลของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรังเพื่อรักษาความปลอดภัยและป้องกันการนำข้อมูลส่วนบุคคลของผู้ใช้บริการเว็บไซต์
                                                ภายใต้ Domain Name “https://e.trangskin.go.th/signature” ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้จังหวัดตรังไปใช้โดยมีเจตนาไม่สุจริต
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๑. การเก็บรวบรวมข้อมูลส่วนบุคคลอย่างจำกัด โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                    จะเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้บริการเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรังเท่าที่จำเป็น
                                                    ได้แก่ ชื่อ นามสกุล เลขประจำตัวประชาชน อีเมล หมายเลขโทรศัพท์ ลายเซ็น เป็นต้น
                                                    โดยขึ้นอยู่กับประเภทของบริการที่ท่านใช้ผ่านเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรังเช่น
                                                    การลงนามคำรับรองอิเล็กทรอนิกส์ การลงทะเบียนกิจกรรมต่าง ๆ ที่ทำผ่านเว็บไซต์ ภายใต้
                                                    Domain Name “https://e.trangskin.go.th/signature” ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๒. การบันทึกข้อมูลผู้ใช้บริการ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง มีการเก็บบันทึกข้อมูลของผู้ใช้บริการเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                    ได้แก่ หมายเลขไอพี (IP Address) วันที่ และเวลา เว็บไซต์ที่เข้าออกก่อนและหลัง ประเภทของโปรแกรมบราวเซอร์ (Browser) ชนิดของโปรแกรมค้นผ่าน (Browser Type)
                                                    โดเมนเนม (Domain Name) บันทึกหน้าเว็บ (web page) เป็นต้น ทั้งนี้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะนำข้อมูลที่ได้บันทึกหรือ เก็บรวบรวมไว้
                                                    ไปใช้ในการวิเคราะห์เชิงสถิติ หรือในการดำเนินการเพื่อปรับปรุงคุณภาพการให้บริการต่อไป โดยการบันทึกข้อมูลดังกล่าวเป็นไปตามมาตรา ๒๖ วรรคหนึ่งแห่งพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์ พ.ศ. ๒๕๕๐
                                                    ซึ่งแก้ไขเพิ่มเติมโดยพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์ (ฉบับที่ ๒) พ.ศ. ๒๕๖๐ ที่กำหนดให้ผู้ให้บริการต้องเก็บข้อมูลจราจรคอมพิวเตอร์ไว้ไม่น้อยกว่า ๙๐ วัน
                                                    นับแต่วันที่ข้อมูลนั้นเข้าสู่ระบบคอมพิวเตอร์ แต่ในกรณีจำเป็น พนักงานเจ้าหน้าที่จะสั่งให้ผู้ให้บริการผู้ใดเก็บรักษาข้อมูลจราจรทางคอมพิวเตอร์ไว้เกิน ๙๐ วัน แต่ไม่เกิน ๒ ปี เป็นกรณีพิเศษเฉพาะรายและเฉพาะคราวก็ได้
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๓. การใช้ข้อมูลส่วนบุคคล โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะเก็บรวบรวม รักษา และใช้ข้อมูลส่วนบุคคลของท่านเพื่อประโยชน์ ในการให้บริการ
                                                    และการดำเนินการตามวัตถุประสงค์และภารกิจของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ภายใต้ขอบเขตของกฎหมายที่เกี่ยวข้อง
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๔. ข้อจำกัดในการนำข้อมูลส่วนบุคคลไปใช้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะมิให้มีการเปิดเผย หรือแสดง หรือทำให้ปรากฏในลักษณะอื่นใดซึ่งข้อมูลส่วนบุคคลที่ไม่สอดคล้องกับวัตถุประสงค์ของการรวบรวมและจัดเก็บข้อมูล
                                                    เว้นแต่จะได้รับความยินยอมจากเจ้าของข้อมูล หรือเป็นกรณีที่มีกฎหมายกำหนดให้กระทำได้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะมิให้มีการเปิดเผยข้อมูลส่วนบุคคลของท่านแก่บุคคลที่สามเพื่อนำไปใช้ในการดำเนินกิจกรรมที่ไม่เกี่ยวข้อง เช่น การเสนอขายสินค้าทางโทรศัพท์ เป็นต้น
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๕. การรักษาความมั่นคงปลอดภัยสำหรับข้อมูลส่วนบุคคล โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง มีการใช้มาตรการด้านความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลอย่างเหมาะสมเพื่อป้องกันการสูญหาย การเข้าถึง ทำลาย ใช้ แปลง แก้ไข
                                                    หรือเปิดเผยข้อมูลโดยมิชอบ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ได้จำกัดการเข้าใช้งานข้อมูลส่วนบุคคลไว้เพียงเจ้าหน้าที่โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ที่เกี่ยวข้อง โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                    กำหนดให้ผู้รับจ้าง (Outsource) จำเป็นต้องเก็บรักษาความลับและความปลอดภัยของข้อมูลของผู้ใช้บริการ โดยห้ามนำข้อมูลไปใช้นอกเหนือจากที่กำหนดให้ดำเนินการ
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๖. ข้อแนะนำในการการรักษาความปลอดภัยข้อมูลส่วนบุคคล การใช้บริการทางอิเล็กทรอนิกส์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ท่านจะได้รับชื่อผู้ใช้งาน
                                                    (User) และรหัสผ่าน (Password) สำหรับเข้าสู่ระบบ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะเป็นผู้กำหนดชื่อผู้ใช้งาน (User) และรหัสผ่าน (Password)
                                                    ให้ท่าน โดยท่านมีหน้าที่รักษาชื่อผู้ใช้งาน (User) และรหัสผ่าน (Password) ของท่านอย่างเคร่งครัด ไม่เปิดเผยข้อมูลดังกล่าวแก่บุคคลอื่น ทั้งนี้ เมื่อระบบได้รับการพัฒนาโดยสมบูรณ์แล้ว
                                                    ท่านสามารถเปลี่ยนรหัสผ่าน (Password) ได้ด้วยตัวของท่านเอง และข้อควรปฏิบัติคือ ทุกครั้งที่ท่านใช้บริการเสร็จแล้ว ควรคลิก “ออกจากระบบ” เพื่อป้องกันมิให้ผู้อื่นสามารถทำรายการจากบัญชีผู้ใช้งานของท่านได้
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๗. การใช้คุกกี้ (Cookies) คุกกี้ (Cookies) เป็นกระบวนการเพื่อทำให้ผู้ใช้บริการสามารถใช้งานเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ได้สะดวกขึ้น
                                                    คุกกี้มีประโยชน์สำหรับให้เว็บเซิร์ฟเวอร์สามารถเรียกใช้ข้อมูลเหล่านั้นได้ในภายหลัง คุกกี้จะถูกติดตั้งในขณะที่ท่านเรียกดูเว็บไซต์ หลังจากที่ท่านเลิกใช้งานโปรแกรมบราวเซอร์ (Browser)
                                                    แล้วคุกกี้บางตัวจะถูกจัดเก็บไว้ที่เครื่องคอมพิวเตอร์ของท่านในรูปแบบไฟล์ หรืออาจจะหมดอายุ หรือไม่มีการเก็บ ท่านสามารถปรับโปรแกรมบราวเซอร์ (Browser) ของท่านให้รองรับการทำงานของคุกกี้หรือไม่ก็ได้
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๘. การปรับปรุงนโยบายการคุ้มครองข้อมูลส่วนบุคคล โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง อาจทำการปรับปรุงหรือแก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคลโดยไม่ได้แจ้งให้ท่านทราบล่วงหน้า ทั้งนี้
                                                    เพื่อความเหมาะสมและประสิทธิภาพในการให้บริการ ดังนั้น โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ขอแนะนำให้ท่านอ่านนโยบายคุ้มครองข้อมูลส่วนบุคคลทุกครั้งที่ใช้บริการเว็บไซต์ Domain Name
                                                    “https://e.trangskin.go.th/signature” ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ๙. การปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลและการติดต่อกับโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง กำหนดให้เจ้าหน้าที่โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                    ที่เกี่ยวข้องต้องให้ความสำคัญและรับผิดชอบในการคุ้มครองข้อมูลส่วนบุคคล เพื่อให้เป็นไปตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        paddingTop: "10px"
                                                    }}
                                                >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    ในกรณีที่ท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใดๆ เกี่ยวกับนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ยินดีที่จะตอบข้อสงสัย รับฟังข้อเสนอแนะ และคำติชมทั้งหลาย
                                                    อันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ต่อไป โดยท่านสามารถติดต่อกับโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ได้ตามช่องทางดังต่อไปนี้
                                                </label>
                                            </label>
                                        </Col>
                                    </Grid>

                                </ModalBody>
                                <div className="modal-footer" style={{
                                    justifyContent: "center"
                                }}>
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalPolicy()}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>


                            }

                        </CardFooter>
                    </Card>
                </Col>

                {fullScreen && <ReactFullScreenElement
                    fullScreen={fullScreen}
                    allowScrollbar={true}
                >
                    <KeyboardEventHandler
                        handleKeys={["esc"]}
                        onKeyEvent={(key, e) => setFullScreenKey(key)}></KeyboardEventHandler>
                    <Card>
                        <CardHeader>
                            <Card>
                            </Card>
                        </CardHeader>
                        <CardBody>
                            <img
                                src={PDF}
                                alt="my signature"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    width: "100%"
                                }}
                            />

                        </CardBody>
                        <CardFooter style={{
                            justifyContent: "center"
                        }}>
                            <Button color="primary" onClick={setFullScreenButton} >
                                <h6 style={{ fontSize: "16px" }}>ตกลง</h6>
                            </Button>
                        </CardFooter>
                    </Card>
                </ReactFullScreenElement>}

                {fullScreen2 && <ReactFullScreenElement
                    fullScreen={fullScreen2}
                    allowScrollbar={true}
                >
                    <KeyboardEventHandler
                        handleKeys={["esc"]}
                        onKeyEvent={(key, e) => setFullScreenKey(key)}></KeyboardEventHandler>
                    <Card>
                        <CardHeader>
                            <Card>
                            </Card>
                        </CardHeader>
                        <CardBody>
                            <img
                                src={PDF}
                                alt="my signature"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    width: "100%"
                                }}
                            />

                        </CardBody>
                        <CardFooter style={{
                            justifyContent: "center"
                        }}>
                            <Button color="primary" onClick={setFullScreenButton2} >
                                <h6 style={{ fontSize: "16px" }}>ตกลง</h6>
                            </Button>
                        </CardFooter>
                    </Card>
                </ReactFullScreenElement>}
            </Grid>

        </div>
    );
};

export default Edit;